const addressToQRCode = (address, { width = 150, height = 150 }) => {
  const dataURL = `https://api.qrserver.com/v1/create-qr-code/?size=${width}x${height}&data=${address}`;
  return dataURL;
};

export default addressToQRCode;
